import rawSicCodes from "./sic.json";

export const sicCodes: { label: string; value: number }[] = rawSicCodes.map((sic) => ({
  label: `${sic.code} ${sic.description}`,
  value: sic.code,
}));
